import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

import { H2, H3 } from "./headings";
import { S3_BUCKET } from "../constants";
import { getFirstLetter } from "../helpers";
import { P, MuiAvatar, ProgressBar } from ".";
import { donationConstants } from "../store/actionTypes";

export function DonationImpactCard({ pageDetails, assignClasses, isFundraiserPage }) {

    const [donationEffect, setDonationEffect] = useState(0);
    const [donationRaisedPercentage, setDonationRaisedPercentage] = useState(0);

    let avatarName, cardTitle, pageCreatedBy;
    const donationImpact = useSelector(state => state.donation.product_impact)
    const donationAmount = useSelector(state => state.donationCheckout.donationAmount);
    const selectedCurrency = useSelector(state => state.donationCheckout.selectedCountry.id);
    const currencyConversionRate = useSelector(state => state.donationCheckout.currencyConversionRate);

    const impactDescription = useMemo(
        () => {
            return donationImpact?.product_impact > 1 ?
                <>lives of <b>{donationImpact.product_impact}</b> students</>
                : <>life of <b>1</b> student</>
        },
        [pageDetails, donationImpact.product_impact]
    );

    if (isFundraiserPage) {
        avatarName = getFirstLetter(pageDetails.first_name) + ' ' + getFirstLetter(pageDetails.last_name);
        cardTitle = pageDetails.page_title;
        pageCreatedBy = pageDetails.first_name + ' ' + pageDetails.last_name;
    }
    else {
        avatarName = getFirstLetter(pageDetails.name);
        cardTitle = pageDetails.name;
        pageCreatedBy = 'TCF';
    }

    const mapGoalDescription = useCallback(
        () => {
            let contentforeRaised, contentForGoal, goalContent;
            if (isFundraiserPage || !pageDetails.campaign_goal) {
                contentforeRaised = isFundraiserPage ?
                    pageDetails.symbol_left + " " + (donationConstants.AMOUNT_FORMAT.includes(pageDetails.code) ? pageDetails.total_fund_raised.toLocaleString('de-DE') : pageDetails.total_fund_raised.toLocaleString())
                    :
                    pageDetails.total_fund_raised.toLocaleString();

                contentForGoal = `raised of ${isFundraiserPage ? pageDetails.symbol_left : ''}`;
                goalContent = "goal"
            }
            else {
                contentforeRaised = "Supporting" + " " + (donationConstants.AMOUNT_FORMAT.includes(pageDetails.code) ? pageDetails.total_fund_raised.toLocaleString('de-DE') : pageDetails.total_fund_raised.toLocaleString());
                contentForGoal = "out of";
                goalContent = "students"
            }

            return <div className="goalamount">
                <H2 content={contentforeRaised} />
                <P>{contentForGoal + ' ' + (donationConstants.AMOUNT_FORMAT.includes(pageDetails.code) ? pageDetails.fundraising_goal.toLocaleString('de-DE') : pageDetails.fundraising_goal.toLocaleString())} {goalContent}</P>
            </div>
        },
        [pageDetails]
    );

    useEffect(() => {
        const totalFundsRaised = isFundraiserPage ? pageDetails.total_fund_raised : pageDetails.int_total_fund_raised;
        const fundraisingGoal = isFundraiserPage ? pageDetails.fundraising_goal : pageDetails.int_fundraising_goal;

        let raisedPercentage = (totalFundsRaised / fundraisingGoal) * 100;
        raisedPercentage = Math.round(raisedPercentage);

        if (raisedPercentage > 100)
            raisedPercentage = 100

        setDonationRaisedPercentage(raisedPercentage);
    }, [])

    useEffect(() => {
        let donationEffect = 0;
        if (donationAmount > 0 && (isFundraiserPage || !pageDetails.campaign_goal)) {

            const totalFundsRaised = isFundraiserPage ? pageDetails.total_fund_raised : pageDetails.int_total_fund_raised;
            const fundraisingGoal = isFundraiserPage ? pageDetails.fundraising_goal : pageDetails.int_fundraising_goal;

            pageDetails.currency_id === selectedCurrency ?
                donationEffect = ((parseFloat(totalFundsRaised) + parseFloat(donationAmount)) / parseFloat(fundraisingGoal)) * 100
                :
                donationEffect = ((parseFloat(totalFundsRaised) + parseFloat((parseFloat(donationAmount)) * (parseFloat(currencyConversionRate)) / (parseFloat(pageDetails.value)))) / (parseFloat(fundraisingGoal))) * 100;

            if (donationEffect > 100)
                donationEffect = 100;

            donationEffect = Math.round(donationEffect - donationRaisedPercentage);

            setDonationEffect(donationEffect);
        }
        else setDonationEffect(0)
    }, [donationAmount])

    useEffect(() => {
        let donationEffect = 0;
        if (donationImpact.product_impact > 0 && !isFundraiserPage && pageDetails.campaign_goal) {
            donationEffect = (donationImpact.product_impact + pageDetails.int_total_fund_raised) / pageDetails.int_fundraising_goal
            donationEffect = donationEffect * 100;
            if (donationEffect > 100) {
                donationEffect = 100;
            }
            donationEffect = Math.round(donationEffect - donationRaisedPercentage);
            setDonationEffect(donationEffect)
        }
        // else setDonationEffect(0)
    }, [donationImpact.product_impact])

    return <div className={assignClasses}>
        <div className="donategoal">
            <div className="imgarea">
                <MuiAvatar className="imgpart" src={S3_BUCKET + pageDetails.profile_image} fullName={pageCreatedBy} variant="square" />
                <div className="right">
                    <P>You're giving to</P>
                    <H2 content={cardTitle} />
                    <P>By {pageCreatedBy}</P>
                </div>
            </div>
            {pageDetails.fundraising_goal &&
                <>
                    {mapGoalDescription()}
                    <div className="scrollrange">
                        {/* Scroll Range */}
                        <ProgressBar percentage={donationRaisedPercentage} donationEffectPercentage={donationEffect} />
                    </div>
                </>
            }
            {pageDetails.show_impact_message == 1 &&
                <div className="impact-txt">
                    <H3 content={"Your Impact"} />
                    {!pageDetails.is_special ? (donationImpact.product_impact > 0
                        ?
                        <P>
                            You are going to impact the {impactDescription}
                        </P>
                        :
                        <P>Your donation will support the general education fund</P>
                    ) :
                        'Your donation supports the flood relief affectees in Pakistan'
                    }
                </div>}
        </div>
    </div>
}